export default (url) => {
  const AL = process.env.ASSETS_LOCATION
  const alreadyHave = !!url && url.includes('http://localhost')
  return (AL && url && !alreadyHave) ? (AL + url) : url
}


// WEBPACK FOOTER //
// ./src/utils/assetURL.js